"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timestampDatePrimitiveSchema = exports.timestampIsoPrimitiveSchema = void 0;
const zod_1 = require("zod");
exports.timestampIsoPrimitiveSchema = zod_1.z.string().datetime();
exports.timestampDatePrimitiveSchema = zod_1.z.coerce.date();
